module.exports = __webpack_public_path__ + "static/img/invest-consume16.bd24b52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-consume16.jpg
// module id = pGOX
// module chunks = 0